<mat-tab-group
  [selectedIndex]="state.activeTabIndex"
  (selectedTabChange)="changeTab($event.index)"
  mat-align-tabs="start"
>
  <mat-tab *ngFor="let tab of tabs; trackBy: trackByName">
    <ng-template matTabLabel>
      <img src="{{ tab.logo }}" class="mr-2" width="15" alt="" />

      <span [attr.data-test]="'orchestration-tables-picker-popup-tab-' + tab.name">{{ tab.name }} </span>
    </ng-template>
  </mat-tab>
</mat-tab-group>
<div class="grow">
  <y42-orchestration-datasource-selector
    *ngIf="state.enableDatasourceSelector"
    [selectedDatasourcePaths]="state.selectedDatasourcePaths"
    (datasourcesSelectionChanged)="datasourcePathsChanged($event)"
  ></y42-orchestration-datasource-selector>
  <y42-orchestration-export-selector
    *ngIf="state.enableExportSelector"
    [selectedIds]="state.selectedExportPaths"
    (exportsSelectionChanged)="exportPathsChanged($event)"
  ></y42-orchestration-export-selector>
</div>
<div class="actions-bar">
  <span *ngIf="state.numberOfDuplicates" class="text-red-700">
    {{ state.numberOfDuplicates }} {{ state.numberOfDuplicates > 1 ? 'Assets are' : 'Asset is' }} already selected.
  </span>
  <div class="ml-auto">
    <button
      mat-raised-button
      color="primary"
      (click)="selectAssets()"
      [disabled]="!state.isSelectionEnabled"
      data-test="orchestration-tables-picker-popup-button-select-asset"
    >
      <span> Select {{ state.selectedAssets.length }} {{ state.selectedAssets.length > 1 ? 'Assets' : 'Asset' }} </span>
    </button>

    <button
      *ngIf="state.allowSelectionWithDependencies"
      mat-raised-button
      color="primary"
      class="ml-3"
      (click)="selectAssets(true)"
      [disabled]="!state.isSelectionEnabled"
    >
      <span>
        Select {{ state.selectedAssets.length }}
        {{ state.selectedAssets.length > 1 ? 'Assets with Dependencies' : 'Asset with Dependencies' }}
      </span>
    </button>
  </div>
</div>
